<template>
  <div :class="$style.container">
    <div :class="[$pgCTStyle.headerContainer, $style.headerContainer]">
      <div :class="$pgCTStyle.title">{{ $t("cast-vote") }}</div>
    </div>
    <template v-if="!props.hasSaboteurVoted">
      <div :class="$pgCTStyle.bodyContainer">
        <!-- <div :class="$style.questionContainer">
            <div :class="$style.question">What is the correct text?</div>
            <div :class="$style.options">
              <label
                v-for="option in texts"
                :key="option.id"
                :class="[$style.option, correctChoiceTextId === option.id ? $style.selected : '']"
              >
                <input type="radio" :value="option.id" v-model="correctChoiceTextId" :class="$style.hiddenRadio" />
                <span :class="$style.radio"></span>
                <span :class="$style.label">Text {{ option.label }}</span>
              </label>
            </div>
          </div> -->

        <!-- <div :class="[$style.questionContainer, $style.questionContainerSeparator]"> -->
        <div :class="[$style.questionContainer]">
          <div :class="$style.question">{{ $t("who-is-saboteur") }}</div>
          <div :class="[$style.dropdownContainer]">
            <select
              v-model="selectedSaboteurId"
              :class="[
                $style.dropdown,
                selectedSaboteurId && selectedSaboteurId.length ? '' : $style.defaultDropdownSelected,
              ]"
            >
              <option :value="null" disabled>{{ $t("type-name") }}</option>
              <option v-for="player in props.groupPlayers" :key="player.id" :value="player.id">
                {{ player.username }}
              </option>
              <option :value="0">{{ $t("no-saboteur") }}</option>
            </select>
          </div>
        </div>

        <div v-if="props.enableFinalReason" :class="[$style.questionContainer, $style.questionContainerSeparator]">
          <div :class="$style.question">{{ $t("saboteur-vote-reason") }}:</div>
          <div :class="$style.textBox">
            <input type="text" :placeholder="$t('type-saboteur-vote-reason')" v-model="voteReason" />
          </div>
        </div>
        <div :class="$style.ctaContainer">
          <PGComponentActionButton
            :text="$t('submit-vote')"
            :iconLink="voteIcon"
            :clickFunction="handleSubmitVote"
            backBg="#A14000"
            frontBg="#DB7532"
            textColor="#FFFFFF"
            :rightIcon="true"
            :buttonWidth="isMobile ? '180px' : isTablet ? '220px' : '260px'"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div :class="$pgCTStyle.bodyContainer">
        <div :class="$style.voteSubmittedContainer">
          <img :class="$style.successIcon" :src="successIcon" alt="Success" />
          <div :class="$style.successText">{{ $t("vote-success") }}</div>
          <div :class="$style.successSubText">{{ $t("saboteur-vote-wait") }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
// import styles from "@/css/CastSaboteurVoteBoxForPlayer.module.css";
import styles from "@/css/CastVoteBoxForPlayer.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
// import globalStyles from "@/css/global.module.css";
import VoteIcon from "@/assets/icons/rubber-stamp.svg";
import SuccessIcon from "@/assets/icons/verified-account.svg";
import { ref } from "vue";
import { toast } from "vue3-toastify";
// import UtilButton from "../util/UtilButton.vue";
import { useI18n } from "vue-i18n";

const { t: translate } = useI18n();
import useDeviceType from "@/utils/useDeviceType";
import PGComponentActionButton from "../buttons/PGComponentActionButton.vue";
//import { has } from "core-js/core/dict";

const device = useDeviceType();

// const width = device.width.value;
// const height = device.height.value;
const isMobile = device.isMobile.value;
const isTablet = device.isTablet.value;
// const isDesktop = device.isDesktop.value;

const $style = styles;
const $pgCTStyle = playGameComponentsTemplateStyles;
// const $globalStyle = globalStyles;
const voteIcon = VoteIcon;
const successIcon = SuccessIcon;

//const voteSubmitted = ref(false);
const correctChoiceTextId = ref(null);
const selectedSaboteurId = ref(null);
const voteReason = ref("");

// eslint-disable-next-line
const props = defineProps({
  groupPlayers: {
    type: Array,
    required: false,
    default: () => [],
  },
  enableFinalReason: {
    type: Boolean,
    required: false,
    default: true,
  },
  submitVote: {
    type: Function,
    required: true,
  },
  hasSaboteurVoted: 
  {
    type: Boolean,
    required: true,
  },
});

async function handleSubmitVote() {
  // console.log("correctChoiceTextId: ", correctChoiceTextId.value);
  // console.log("selectedSaboteurId: ", selectedSaboteurId.value);
  // console.log("voteReason: ", voteReason.value);

  // if (!this.correctChoiceTextId) {
  //   toast("Please choose a correct text!", {
  //     type: "error",
  //   });

  //   return;
  // }

  if (selectedSaboteurId.value == null) {
    toast(translate("error-saboteur-vote-selection"), {
      type: "error",
    });

    return;
  }

  if (!voteReason.value && props.enableFinalReason) {
    toast(translate("error-saboteur-vote-reason"), {
      type: "error",
    });

    return;
  }

  let voteObj = {
    votedTextId: correctChoiceTextId.value,
    voteReason: voteReason.value,
    votedSaboteurId: selectedSaboteurId.value,
  };

  // emit a function
  try {
     await props.submitVote(voteObj);

    // if (voteRes) {
    //   // show vote submitted screen
    //   voteSubmitted.value = true;
    // }
  } catch (error) {
    console.error("Failed to submit vote:", error);
  } finally {
    // do any common loader here
  }
}
</script>

<style scoped></style>
